"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER_EXPENSE = exports.CHARITY = exports.DISABLED_FAMILY = exports.CONTRIBUTIONS_TO_FAMILY = exports.NOT_DEDUCTED_ALIMONY = exports.CHILD_EDUCTION = exports.DAYCARE_BABYSITTER = exports.OTHER_INSURANCE = exports.VEHICLE_LEASE = exports.VEHICLE_INSTALLMENTS = exports.INSTALLMENT_LEASE = exports.OTHER_TRANSPORTATION = exports.VEHICLE_INSURANCE = exports.VEHICLE_MAINTENANCE = exports.GASOLINE = exports.RETIREMENT_LOANS = exports.LIFE_INSURANCE = exports.NOT_DEDUCTED_HEALTH_INSURANCE = exports.CONTACTS = exports.GLASSES = exports.VISION_EXPENSES = exports.DENTAL_PRESCRIPTIONS = exports.DENTAL_EXPENSES = exports.MEDICAL_PRESCRIPTIONS = exports.MEDICAL_EXPENSES = exports.TAX_PAYMENTS = exports.RECREATION = exports.CLOTHING = exports.CLEANING_LAUNDRY = exports.HAIR_CUTS = exports.PERSONAL_CARE = exports.GROCERIES = exports.OTHER_UTILITIES = exports.CELL_PHONE = exports.CABLE_PHONE_INTERNET = exports.WATER_SEWER_TRASH = exports.HEAT = exports.ELECTRIC = exports.OTHER_PROPERTY_EXPENSE = exports.HOA_CONDO_FEES = exports.UPKEEP_REPAIRS = exports.PROPERTY_INSURANCE = exports.PROPERTY_TAXES = exports.MORTGAGE_RENT = exports.PROPERTY = void 0; // Property

var PROPERTY = 'property';
exports.PROPERTY = PROPERTY;
var MORTGAGE_RENT = 'mortgageRent';
exports.MORTGAGE_RENT = MORTGAGE_RENT;
var PROPERTY_TAXES = 'propertyTaxes';
exports.PROPERTY_TAXES = PROPERTY_TAXES;
var PROPERTY_INSURANCE = 'propertyInsurance';
exports.PROPERTY_INSURANCE = PROPERTY_INSURANCE;
var UPKEEP_REPAIRS = 'upkeepRepairs';
exports.UPKEEP_REPAIRS = UPKEEP_REPAIRS;
var HOA_CONDO_FEES = 'hoaCondoFees';
exports.HOA_CONDO_FEES = HOA_CONDO_FEES;
var OTHER_PROPERTY_EXPENSE = 'otherPropertyExpense'; // Utilities

exports.OTHER_PROPERTY_EXPENSE = OTHER_PROPERTY_EXPENSE;
var ELECTRIC = 'electric';
exports.ELECTRIC = ELECTRIC;
var HEAT = 'heat';
exports.HEAT = HEAT;
var WATER_SEWER_TRASH = 'waterSewerTrash';
exports.WATER_SEWER_TRASH = WATER_SEWER_TRASH;
var CABLE_PHONE_INTERNET = 'cablePhoneInternet';
exports.CABLE_PHONE_INTERNET = CABLE_PHONE_INTERNET;
var CELL_PHONE = 'cellPhone';
exports.CELL_PHONE = CELL_PHONE;
var OTHER_UTILITIES = 'otherUtilities'; // Household

exports.OTHER_UTILITIES = OTHER_UTILITIES;
var GROCERIES = 'groceries';
exports.GROCERIES = GROCERIES;
var PERSONAL_CARE = 'personalCare';
exports.PERSONAL_CARE = PERSONAL_CARE;
var HAIR_CUTS = 'hairCuts';
exports.HAIR_CUTS = HAIR_CUTS;
var CLEANING_LAUNDRY = 'cleaningLaundry';
exports.CLEANING_LAUNDRY = CLEANING_LAUNDRY;
var CLOTHING = 'clothing';
exports.CLOTHING = CLOTHING;
var RECREATION = 'recreation'; // Taxes

exports.RECREATION = RECREATION;
var TAX_PAYMENTS = 'taxPayments'; // Health/Medical/Insurance

exports.TAX_PAYMENTS = TAX_PAYMENTS;
var MEDICAL_EXPENSES = 'medicalExpenses';
exports.MEDICAL_EXPENSES = MEDICAL_EXPENSES;
var MEDICAL_PRESCRIPTIONS = 'medicalPrescriptions';
exports.MEDICAL_PRESCRIPTIONS = MEDICAL_PRESCRIPTIONS;
var DENTAL_EXPENSES = 'dentalExpenses';
exports.DENTAL_EXPENSES = DENTAL_EXPENSES;
var DENTAL_PRESCRIPTIONS = 'dentalPrescriptions';
exports.DENTAL_PRESCRIPTIONS = DENTAL_PRESCRIPTIONS;
var VISION_EXPENSES = 'visionExpenses';
exports.VISION_EXPENSES = VISION_EXPENSES;
var GLASSES = 'glasses';
exports.GLASSES = GLASSES;
var CONTACTS = 'contacts';
exports.CONTACTS = CONTACTS;
var NOT_DEDUCTED_HEALTH_INSURANCE = 'notDeductedHealthInsurance';
exports.NOT_DEDUCTED_HEALTH_INSURANCE = NOT_DEDUCTED_HEALTH_INSURANCE;
var LIFE_INSURANCE = 'lifeInsurance';
exports.LIFE_INSURANCE = LIFE_INSURANCE;
var RETIREMENT_LOANS = 'retirementLoans'; // Transportation

exports.RETIREMENT_LOANS = RETIREMENT_LOANS;
var GASOLINE = 'gasoline';
exports.GASOLINE = GASOLINE;
var VEHICLE_MAINTENANCE = 'vehicleMaintenance';
exports.VEHICLE_MAINTENANCE = VEHICLE_MAINTENANCE;
var VEHICLE_INSURANCE = 'vehicleInsurance';
exports.VEHICLE_INSURANCE = VEHICLE_INSURANCE;
var OTHER_TRANSPORTATION = 'otherTransportation';
exports.OTHER_TRANSPORTATION = OTHER_TRANSPORTATION;
var INSTALLMENT_LEASE = 'installmentLease';
exports.INSTALLMENT_LEASE = INSTALLMENT_LEASE;
var VEHICLE_INSTALLMENTS = 'vehicleInstallments';
exports.VEHICLE_INSTALLMENTS = VEHICLE_INSTALLMENTS;
var VEHICLE_LEASE = 'vehicleLease'; // Other Insurance

exports.VEHICLE_LEASE = VEHICLE_LEASE;
var OTHER_INSURANCE = 'otherInsurance'; // Childcare

exports.OTHER_INSURANCE = OTHER_INSURANCE;
var DAYCARE_BABYSITTER = 'daycareBabysitter';
exports.DAYCARE_BABYSITTER = DAYCARE_BABYSITTER;
var CHILD_EDUCTION = 'childEducation';
exports.CHILD_EDUCTION = CHILD_EDUCTION;
var NOT_DEDUCTED_ALIMONY = 'notDeductedAlimony'; // Contributions

exports.NOT_DEDUCTED_ALIMONY = NOT_DEDUCTED_ALIMONY;
var CONTRIBUTIONS_TO_FAMILY = 'contributionsToFamily';
exports.CONTRIBUTIONS_TO_FAMILY = CONTRIBUTIONS_TO_FAMILY;
var DISABLED_FAMILY = 'disabledFamily';
exports.DISABLED_FAMILY = DISABLED_FAMILY;
var CHARITY = 'charity'; // Other

exports.CHARITY = CHARITY;
var OTHER_EXPENSE = 'otherExpense';
exports.OTHER_EXPENSE = OTHER_EXPENSE;